// Tangier → Marrakech · 9 nights / 10 days. Same as the 8n/9d route
// but adds a full extra day exploring the High Atlas Central and the
// M'Goun gorges. 100% composed from existing days.

import {
  DAY_03_ERFOUD_ERG_BIVOUAC,
  DAY_06_TODRA_DADES,
  DAY_07_MGOUN_ATLAS,
  DAY_08_AITBENHADDOU_MARRAKECH,
} from "./fezMarrakech910";
import {
  DAY_04_AMANECER_KHAMLIA_RISSANI_RELAX,
  DAY_07_MARRAKECH_MEDINA_RETURN,
} from "./fezMarrakech67";
import {
  DAY_TRK_TANGER_CHEFCHAOUEN,
  DAY_TRK_VOLUBILIS_MEKNES_FEZ,
  DAY_TRK_FEZ_DISCOVER,
  DAY_TRK_FEZ_ATLAS_ERFOUD,
} from "./tangerRak89";

const T = (es, en, fr) => ({ es, en, fr });

export const PROGRAM_TRK_910 = {
  routeId: "tourTangerRak910",
  duration_key: "trk9n10d",
  duration: T("9 noches / 10 días", "9 nights / 10 days", "9 nuits / 10 jours"),
  prices: { low: 2290, mid: 2590, high: 2890, premium: 3290 },
  route: [
    { day: 1,  lat: 35.1689, lng: -5.2636, type: "city",    name: T("Chefchaouen", "Chefchaouen", "Chefchaouen") },
    { day: 2,  lat: 34.0651, lng: -4.9760, type: "city",    name: T("Volubilis · Meknes · Fez", "Volubilis · Meknes · Fez", "Volubilis · Meknès · Fès") },
    { day: 3,  lat: 34.0651, lng: -4.9760, type: "city",    name: T("Fez · Medina UNESCO", "Fez · UNESCO Medina", "Fès · Médina UNESCO") },
    { day: 4,  lat: 31.4373, lng: -4.2330, type: "city",    name: T("Erfoud · Kasbah Xaluca", "Erfoud · Kasbah Xaluca", "Erfoud · Kasbah Xaluca") },
    { day: 5,  lat: 31.1257, lng: -3.9789, type: "desert",  name: T("Erg Chebbi · Bivouac", "Erg Chebbi · Bivouac", "Erg Chebbi · Bivouac") },
    { day: 6,  lat: 31.2828, lng: -4.2683, type: "market",  name: T("Rissani · Kasbah Xaluca", "Rissani · Kasbah Xaluca", "Rissani · Kasbah Xaluca") },
    { day: 7,  lat: 31.3582, lng: -5.9911, type: "gorge",   name: T("Boumalne Dadès · Todra", "Boumalne Dades · Todra", "Boumalne Dadès · Todra") },
    { day: 8,  lat: 31.4900, lng: -5.7950, type: "gorge",   name: T("Gargantas del M'Goun", "M'Goun Gorges", "Gorges du M'Goun") },
    { day: 9,  lat: 31.0470, lng: -7.1294, type: "unesco",  name: T("Aït Ben Haddou · Marrakech", "Aït Ben Haddou · Marrakech", "Aït Ben Haddou · Marrakech") },
    { day: 10, lat: 31.6295, lng: -7.9811, type: "city",    name: T("Marrakech · Medina", "Marrakech · Medina", "Marrakech · Médina") },
  ],
  days: [
    DAY_TRK_TANGER_CHEFCHAOUEN,
    DAY_TRK_VOLUBILIS_MEKNES_FEZ,
    DAY_TRK_FEZ_DISCOVER,
    DAY_TRK_FEZ_ATLAS_ERFOUD,
    DAY_03_ERFOUD_ERG_BIVOUAC,
    DAY_04_AMANECER_KHAMLIA_RISSANI_RELAX,
    DAY_06_TODRA_DADES,
    DAY_07_MGOUN_ATLAS,
    DAY_08_AITBENHADDOU_MARRAKECH,
    DAY_07_MARRAKECH_MEDINA_RETURN,
  ],
  details: {
    includes: {
      es: [
        "Una noche en Chefchaouen en Riad en la Medina en Media Pensión",
        "Dos noches en Fez en Riad en la Medina o Hotel 4★ en Media Pensión",
        "Dos noches en Erfoud en Kasbah Hotel Xaluca en Media Pensión",
        "Una noche en Erg Chebbi en Bivouac de Luxe en el desierto en Media Pensión",
        "Dos noches en Boumalne Dades en Hotel Xaluca Dadès en Media Pensión",
        "Una noche en Marrakech en Riad en la Medina o Hotel 5★ en Alojamiento y Desayuno",
        "Comida picnic en el desierto · Almuerzo en «Gîte d'Étape» en M'Goun",
        "Excursión en dromedario por el Erg Chebbi",
        "Vehículo 4x4 con chófer del día 1 al día 9 del itinerario",
        "Visita guiada a las Grutas de Hércules y Cabo Espartel",
        "Visita con guías locales en Chefchaouen, Meknes, Fez y Marrakech",
        "Entrada a las ruinas romanas de Volubilis",
        "Entrada al Palacio de la Bahía",
        "Visita a la Kasbah de Aït Ben Haddou",
        "Transfers desde y hacia aeropuertos · Combustible · Seguro de asistencia en viaje",
      ],
      en: [
        "One night in Chefchaouen at a Medina riad · half board",
        "Two nights in Fez at a Medina riad or 4★ hotel · half board",
        "Two nights in Erfoud at Kasbah Hotel Xaluca · half board",
        "One night at the Bivouac de Luxe in the Erg Chebbi · half board",
        "Two nights in Boumalne Dades at Hotel Xaluca Dades · half board",
        "One night in Marrakech at a Medina riad or 5★ hotel · bed & breakfast",
        "Picnic lunch in the desert · Mountain lunch at a «Gîte d'Étape» in the M'Goun",
        "Camel ride in the Erg Chebbi",
        "4x4 with driver from day 1 to day 9",
        "Guided visit to the Hercules' Caves and Cape Spartel",
        "Local guided tours in Chefchaouen, Meknes, Fez and Marrakech",
        "Entrance to the Roman ruins of Volubilis",
        "Entrance to the Bahia Palace",
        "Visit to the Aït Ben Haddou Kasbah",
        "Airport transfers · Fuel · Travel assistance insurance",
      ],
      fr: [
        "Une nuit à Chefchaouen en riad de la médina · demi-pension",
        "Deux nuits à Fès en riad de la médina ou hôtel 4★ · demi-pension",
        "Deux nuits à Erfoud à la Kasbah Hôtel Xaluca · demi-pension",
        "Une nuit au Bivouac de Luxe dans l'Erg Chebbi · demi-pension",
        "Deux nuits à Boumalne Dadès à l'Hôtel Xaluca Dadès · demi-pension",
        "Une nuit à Marrakech en riad de la médina ou hôtel 5★ · petit-déjeuner",
        "Pique-nique au désert · Déjeuner en « Gîte d'Étape » dans le M'Goun",
        "Balade à dromadaire dans l'Erg Chebbi",
        "4x4 avec chauffeur du jour 1 au jour 9",
        "Visite guidée des Grottes d'Hercule et du Cap Spartel",
        "Guides locaux à Chefchaouen, Meknès, Fès et Marrakech",
        "Entrée aux ruines romaines de Volubilis",
        "Entrée au Palais de la Bahia",
        "Visite de la Kasbah d'Aït Ben Haddou",
        "Transferts aéroports · Carburant · Assistance voyage",
      ],
    },
    excludes: {
      es: [
        "Las bebidas",
        "Las comidas a mediodía no especificadas",
        "Las cenas en Marrakech",
        "Otros extras personales (quads, masajes, tratamientos de spa…)",
        "El vuelo (salvo que se indique lo contrario)",
        "Suplemento opcional para seguro de cancelación · 45 € por persona para viajes de hasta 9 días",
      ],
      en: [
        "Drinks",
        "Lunches not specified",
        "Dinners in Marrakech",
        "Personal extras (quads, massages, spa treatments…)",
        "Flights (unless otherwise stated)",
        "Optional cancellation insurance · €45 per person for trips up to 9 days",
      ],
      fr: [
        "Boissons",
        "Déjeuners non spécifiés",
        "Dîners à Marrakech",
        "Extras personnels (quads, massages, spa…)",
        "Le vol (sauf mention contraire)",
        "Assurance annulation en option · 45 € par personne pour les voyages jusqu'à 9 jours",
      ],
    },
    notes: {
      es: [
        "Opciones de vuelos: Royal Air Maroc, Vueling, Ryanair.",
        "Las tarifas se calculan según la ocupación del 4x4. El coste se divide entre los ocupantes.",
        "Tarifas basadas en habitaciones dobles/triples. Suplemento individual: 455 €.",
        "Descuento niños (3-11 años) compartiendo con dos adultos: 410 € temporada baja · 430 € temporada alta.",
        "En temporada alta, los guías de medina pueden compartirse con otros viajeros.",
        "Chóferes hispanohablantes son limitados — reservar con antelación.",
        "Los guías oficiales están reservados exclusivamente para las visitas a las medinas, no para las rutas.",
        "Es obligatorio pasaporte vigente con un mínimo de 6 meses desde la fecha de regreso.",
        "Actividades opcionales: Quads 90 € por vehículo (2 horas).",
      ],
      en: [
        "Flight options: Royal Air Maroc, Vueling, Ryanair.",
        "Rates depend on 4x4 occupancy. Cost is split between passengers.",
        "Rates based on double/triple rooms. Single room supplement: €455.",
        "Children discount (3-11) sharing with two adults: €410 low season · €430 high season.",
        "In high season medina guides may be shared with other travellers.",
        "Spanish-speaking drivers are limited — book early.",
        "Official guides are reserved exclusively for medina visits, not for the on-road portions.",
        "Valid passport required with at least 6 months remaining from the return date.",
        "Optional activities: Quads €90 per vehicle (2-hour circuit).",
      ],
      fr: [
        "Options de vols : Royal Air Maroc, Vueling, Ryanair.",
        "Tarifs selon l'occupation du 4x4. Le coût est partagé entre les occupants.",
        "Tarifs base chambre double/triple. Supplément single : 455 €.",
        "Remise enfants (3-11 ans) partageant avec 2 adultes : 410 € basse · 430 € haute.",
        "En haute saison, les guides de médina peuvent être partagés.",
        "Chauffeurs hispanophones limités — réserver tôt.",
        "Les guides officiels sont réservés aux visites des médinas, pas aux trajets.",
        "Passeport valable au minimum 6 mois après la date de retour.",
        "Activités en option : Quads 90 € par véhicule (2 h).",
      ],
    },
    terms: {
      es: [
        "Ficha de inscripción obligatoria. Pago por transferencia o Visa.",
        "Reserva: 30% del importe total al confirmar.",
        "Pago final: 70% restante hasta 30 días antes de la salida.",
        "Si el vuelo elegido requiere emisión inmediata: 100% del importe de vuelos + 30% de los servicios de tierra al reservar.",
        "Cancelación 45 días antes de la salida: 30% del importe total.",
        "Cancelación 21 días antes de la salida: 100% del importe total.",
        "Penalización fija de 50 € por reserva en concepto de gastos de gestión.",
        "Los vuelos y el seguro de cancelación no son reembolsables.",
      ],
      en: [
        "Compulsory booking form. Payment by bank transfer or Visa.",
        "Booking: 30% of the total at confirmation.",
        "Final payment: 70% balance up to 30 days before departure.",
        "If the chosen flight requires immediate ticketing: 100% of the flight + 30% of land services at booking.",
        "Cancellation 45 days before departure: 30% of the total.",
        "Cancellation 21 days before departure: 100% of the total.",
        "Fixed €50 per booking management fee.",
        "Flights and cancellation insurance are non-refundable.",
      ],
      fr: [
        "Fiche d'inscription obligatoire. Paiement par virement bancaire ou Visa.",
        "Réservation : 30 % du total à la confirmation.",
        "Paiement final : solde de 70 % jusqu'à 30 jours avant le départ.",
        "Si le vol exige une émission immédiate : 100 % du vol + 30 % des services terrestres à la réservation.",
        "Annulation 45 jours avant : 30 % du total.",
        "Annulation 21 jours avant : 100 % du total.",
        "Pénalité fixe de 50 € par réservation pour frais de gestion.",
        "Les vols et l'assurance annulation ne sont pas remboursables.",
      ],
    },
  },
};

export default PROGRAM_TRK_910;
